import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";

import { Banco } from '@app/models/banco.model';
import { BancoService } from '@app/services/banco.service';

@Component({
  selector: 'app-banco-form',
  templateUrl: './banco-form.component.html'
})
export class BancoFormComponent implements OnInit {

  aguardandoSolicitacao : boolean = false;
  titulo: string;
  lstErros: string[];
  banco: Banco = new Banco();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private bancoService: BancoService
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      let id = params['id'];
      this.titulo = id ? 'Editar Banco' : 'Novo Banco';

      if (!id)
        return;

      this.bancoService.obterPorId(id).toPromise().then(
        data => this.banco = data,
        () => this.router.navigate(['./configuracoes/banco']));
    });
  }

  onSubmit() {
    this.aguardandoSolicitacao = true;
    this.bancoService.gravar(this.banco).toPromise().then(
      () => this.router.navigate(["./configuracoes/banco"]),
      (data: any) => {
        if (data.error){
          this.lstErros = data.error.errors;
        }
        this.aguardandoSolicitacao = false;
      });
  }
}
